module.exports = __webpack_public_path__ + "media/images/gallery/dn_tab_off-dfb3b005adf7297d8311a6cdd0badd30.jpg";